import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import type { AddonTypeName } from "app/contexts/AddonStateContext/const";
import { NoTouchPurchaseSummaryModalTitleContainer } from "app/components/no-touch-purchase-modal/summary-modal/title/StyledNoTouchPurchaseSummaryModalTitle";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";

interface INoTouchPurchaseSummaryModalTitleProps {
    addonType: AddonTypeName;
    onClose: () => void;
}

export const NoTouchPurchaseSummaryModalTitle = ({ addonType, onClose }: INoTouchPurchaseSummaryModalTitleProps) => {
    const { translate } = useTranslate();

    return (
        <NoTouchPurchaseSummaryModalTitleContainer>
            <Text fontVariant="h5">{translate(NO_TOUCH_PURCHASE_TRANSLATIONS.summary[addonType].title)}</Text>
            <IconButton
                type="flat"
                onClick={onClose}
                iconName="clear"
                placement="left"
                iconSize="sm"
            />
        </NoTouchPurchaseSummaryModalTitleContainer>
    );
};
